export default "__VITE_ASSET__xix5JSEf__"